import PropTypes from "prop-types";

import { brPt, corDaNota } from "../lib/format";

/* Comparação em barras horizontais — sempre o aluno vs. médias de escopos
   mais amplos, NUNCA aluno vs. aluno: o Portal do Responsável não lista nem
   compara outros alunos (decisão de produto, ver README do módulo). */
export function ComparativoNota({ linhas }) {
  const validas = linhas.filter(l => l.valor !== null && l.valor !== undefined);
  if (validas.length === 0) {
    return (
      <p className="text-muted mb-0" style={{ fontSize: 13 }}>
        Sem nota registrada para comparar neste período.
      </p>
    );
  }

  return (
    <div>
      {linhas.map(linha => (
        <LinhaComparativo key={linha.label} linha={linha} />
      ))}
    </div>
  );
}

ComparativoNota.propTypes = {
  linhas: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      valor: PropTypes.number,
      destaque: PropTypes.bool,
      subLabel: PropTypes.string
    })
  ).isRequired
};

function LinhaComparativo({ linha }) {
  const pct =
    linha.valor == null
      ? 0
      : Math.max(2, Math.min(100, (linha.valor / 10) * 100));
  return (
    <div className="mb-2">
      <div className="d-flex align-items-center" style={{ gap: 10 }}>
        <span
          style={{
            width: 108,
            fontSize: 12.5,
            color: linha.destaque ? "#2b2b2b" : "#6b7280",
            fontWeight: linha.destaque ? 600 : 400,
            flexShrink: 0
          }}
        >
          {linha.label}
        </span>
        <div
          style={{
            flex: 1,
            height: 10,
            borderRadius: 6,
            background: "#eef0f3",
            overflow: "hidden"
          }}
        >
          <div
            style={{
              width: `${pct}%`,
              height: "100%",
              borderRadius: 6,
              background: linha.destaque ? corDaNota(linha.valor) : "#8a93a2",
              transition: "width 500ms ease"
            }}
          />
        </div>
        <span
          style={{
            width: 40,
            textAlign: "right",
            fontSize: 13,
            fontWeight: 700,
            color: linha.valor == null ? "#8a93a2" : corDaNota(linha.valor),
            flexShrink: 0
          }}
        >
          {brPt(linha.valor)}
        </span>
      </div>
      {linha.subLabel && (
        <div
          className="text-muted"
          style={{ fontSize: 10.5, marginLeft: 118, marginTop: 2 }}
        >
          {linha.subLabel}
        </div>
      )}
    </div>
  );
}
